module.exports = __webpack_public_path__ + "static/gallery-5-29395331f740c7e2bbf42c80ca1b867f.jpg";